import localforage from "localforage";

window.log = true;

window.localforage = localforage;
window.localforage.config({ name: 'General', version: 1.0 });
window.locationStore = localforage.createInstance({ name: 'Locations' });
window.teamStore = localforage.createInstance({ name: 'Teams' });
window.employeeStore = localforage.createInstance({ name: 'Employees' });
window.activityStore = localforage.createInstance({ name: 'Activities' });
window.rowStore = localforage.createInstance({ name: 'Rows' });
window.packagingsStore = localforage.createInstance({ name: 'Packagings' });
window.percentagesStore = localforage.createInstance({ name: 'Percentages' });

window.workdayStore = localforage.createInstance({ name: 'Workdays' });
window.timesheetStore = localforage.createInstance({ name: 'TimesheetEntries' });

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Array.prototype.contains = function ( needle ) {
    for (let i in this) {
        if (this[i] == needle) return true;
    }
    return false;
}

String.prototype.toHHMMSS = function () {
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours+':'+minutes+':'+seconds;
};
